<template>
  <div class="transfer_box">
    <div class="calls_title">{{ type == 0 ? lang.call_in_progress : lang.transfer_call }}</div>
    <div class="calls_list">
      <div class="calls_list_item" v-for="(call, idx) in callsList" :key="idx">
        <div class="call_info">
          <div class="avatar"></div>
          <div class="num">{{ call.to }}</div>
        </div>
        <div class="call_btns">
          <div class="btn_item answer" v-if="type == 0" @click="$emit('transferFun', type, true)">
            <el-tooltip effect="dark" :content="lang.complete_transfer" placement="top">
              <i class="el-icon-check"></i>
            </el-tooltip>
          </div>
          <div class="btn_item cancel" @click="$emit('transferFun', type, false)">
            <!-- <font-awesome-icon :icon="['fas', 'phone']" /> -->
            <el-tooltip effect="dark" :content="lang.cancel_transfer" placement="top">
              <i class="el-icon-close"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "transfer",
    props: ["callsList", "lang", "type"],
    methods: {}
  }
</script>

<style lang="scss" scoped>
.transfer_box {
  padding: 10px 0;
  .calls_title{
    padding: 5px 0;
    font-size: 18px;
    border-bottom: 1px solid #4DB1EC;
    font-weight: bold;
  }
  .calls_list{
    .calls_list_item {
      background: #eff5f8;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      min-height: 60px;
      .call_info, .call_btns {
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
      .call_info{
        .num{
          font-weight: bold;
        }
      }
      .call_btns{
        .btn_item {
          margin: 0 10px;
          cursor: pointer;
          [class*=" el-icon-"], [class^=el-icon-]{
            font-weight: bold;
          }
          &.answer{
            color: #5D9048;
          }
          &.cancel{
            //transform: rotateZ(135deg);
            color: #c80000;
          }
        }
      }

    }
  }
}
</style>